export const PropertyObjectTypes = {
  CONTACT: 'CONTACT',
  COMPANY: 'COMPANY',
  DEAL: 'DEAL',
  TICKET: 'TICKET',
  SHIPMENT: 'SHIPMENT',
  CUSTOM: 'CUSTOM',
  FEEDBACK_SUBMISSION: 'FEEDBACK_SUBMISSION',
  FEEDBACK: 'FEEDBACK',
  PRODUCT: 'PRODUCT',
  UNKNOWN: 'UNKNOWN',
  MARKETING_EVENT: 'MARKETING_EVENT'
};
export const PropertyObjectTypesIds = {
  [PropertyObjectTypes.UNKNOWN]: '0-0',
  [PropertyObjectTypes.CONTACT]: '0-1',
  [PropertyObjectTypes.TICKET]: '0-5',
  [PropertyObjectTypes.COMPANY]: '0-2',
  [PropertyObjectTypes.DEAL]: '0-3',
  [PropertyObjectTypes.SHIPMENT]: '0-x',
  [PropertyObjectTypes.PRODUCT]: '0-7',
  [PropertyObjectTypes.CUSTOM]: '0-x',
  [PropertyObjectTypes.FEEDBACK_SUBMISSION]: '0-1',
  [PropertyObjectTypes.FEEDBACK]: '0-19',
  [PropertyObjectTypes.MARKETING_EVENT]: '0-54'
};